<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpSmall from '@/assets/images/cp-small.png'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  extends: BaseModal,
  data: function () {
    return { CpSmall }
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  }
}
</script>

<template lang="pug">
span
  .modal-header
  .modal-body
    h1.page__header {{ $t('modals.noAvailableBoxesModal.header') }}
    h3.page__description.mb-5 {{ $t('modals.noAvailableBoxesModal.subheader') }}
    .row
      .col-12.col-lg-4.offset-lg-4
        img.w-100.p-5(:src="CpSmall")
  .modal-footer.fixed
    .row.h-100
      .col-12.col-lg-3.h-100.d-flex.align-items-center
        button.btn.btn-primary.btn-block(type="button" v-ea-click="() => {close(true)}") OK
</template>

<style lang="scss" scoped></style>
